import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "onClick", "text", "hideLink", "disableLink", "loading", "nestedChildren", "tooltipLabel", "href", "icon", "fullText"];
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EPNavigationItem = ({
  className,
  navItem
}) => {
  const {
      id,
      onClick = emptyFunction.thatReturns,
      text,
      hideLink,
      disableLink,
      loading,
      nestedChildren,
      tooltipLabel,
      href = undefined
    } = navItem,
    rest = _objectWithoutPropertiesLoose(navItem, _excluded);
  if (hideLink) {
    return null;
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltipLabel,
    placement: "right",
    children: /*#__PURE__*/_jsxs(UIButton, Object.assign({}, rest, {
      disabled: disableLink || loading,
      className: `${className} display-flex align-center justify-between`,
      "data-nav-item": id,
      "data-test-id": id,
      onClick: onClick,
      href: href,
      use: "link-on-dark",
      children: [text, loading && /*#__PURE__*/_jsx(UILoadingSpinner, {
        className: "m-all-0",
        layout: "inline",
        size: "extra-small",
        use: "on-dark"
      }), !!nestedChildren && /*#__PURE__*/_jsx(UIIcon, {
        name: "right",
        size: "xxs",
        className: "right-arrow-expand"
      })]
    }))
  });
};
EPNavigationItem.propTypes = {
  navItem: PropTypes.object.isRequired,
  listClassName: PropTypes.string,
  linkClassName: PropTypes.string,
  onClick: PropTypes.func
};
export default EPNavigationItem;